import { useCallback, useMemo } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { CatalogItemLayers } from "@l2r-front/l2r-common"
import { ImageCollectionLayer, ImageSelectedLayer, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { NetworkReferentialLayer, useNavigateToLinearLocation, useNetworksDispatchContext } from "@l2r-front/l2r-networks"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { APP_CITY } from "../../../../common/constants/appCity"
import { API_MODULE_HORIZONTAL_SIGNING, MODULE_HORIZONTAL_SIGNING } from "../../../../common/constants/modules"
import { HORIZONTAL_SIGNING_ANTI_TAGS_URL_PARAM, HORIZONTAL_SIGNING_CODE_URL_PARAM, HORIZONTAL_SIGNING_CONDITION_URL_PARAM, HORIZONTAL_SIGNING_TAGS_URL_PARAM } from "../../constants/urlParams"
import { HorizontalSigningSource } from "../../containers/HorizontalSigningSource"

import { HorizontalSignValidator } from "../HorizontalSignValidator"

export function HorizontalSigningMapLayersRouter() {

    const matchRoad = useMatch(`:slugId/${APP_CITY}/${MODULE_HORIZONTAL_SIGNING}/:road/*`)
    const road = matchRoad?.params?.road ? decodeURIComponent(matchRoad.params.road) : null
    const isSegmentView = !!matchRoad

    const navigateToLinearLocation = useNavigateToLinearLocation()
    const { setSegmentFeatureIdClicked } = useImageCollectionDispatchContext()
    const { setSelectedLinearLocations } = useNetworksDispatchContext()

    const { getParam } = useUrlParams()
    const filterType = getParam(HORIZONTAL_SIGNING_CODE_URL_PARAM)
    const filterConditionsParam = getParam(HORIZONTAL_SIGNING_CONDITION_URL_PARAM)
    const filterConditions = useMemo(() => filterConditionsParam ? filterConditionsParam.split(",").map(condition => parseInt(condition)) : null, [filterConditionsParam])
    const filterTagsParams = getParam(HORIZONTAL_SIGNING_TAGS_URL_PARAM)
    const filterTags = useMemo(() => filterTagsParams ? filterTagsParams.split(",") : null, [filterTagsParams])
    const filterAntiTagsParams = getParam(HORIZONTAL_SIGNING_ANTI_TAGS_URL_PARAM, true)
    const filterAntiTags = useMemo(() => filterAntiTagsParams ? filterAntiTagsParams.split(",") : null, [filterAntiTagsParams])
    const filters = useMemo(() => ({
        type: filterType,
        conditions: filterConditions,
        tags: filterTags,
        antiTags: filterAntiTags,
    }), [filterType, filterConditions, filterTags, filterAntiTags])

    const processNavigation = useCallback((feature, location, navigationOrigin) => {
        if (location && location.road && location.road !== road) {
            setSegmentFeatureIdClicked(feature?.properties?.uuid)
            setSelectedLinearLocations(feature)
            navigateToLinearLocation(location, ".", { saveMapBoundingBox: !isSegmentView, navigationOrigin: navigationOrigin })
        }
    }, [setSegmentFeatureIdClicked, setSelectedLinearLocations, navigateToLinearLocation, isSegmentView, road])

    const layers = useMemo(() => {
        return (
            <>
                <NetworkReferentialLayer module={API_MODULE_HORIZONTAL_SIGNING} processNavigation={processNavigation} />
                <CatalogItemLayers Source={HorizontalSigningSource} sourceProps={{ filters }} />
                {isSegmentView && <ImageCollectionLayer road={road} />}
                {isSegmentView && <ImageSelectedLayer />}
            </>
        )
    }, [isSegmentView, processNavigation, road, filters])

    const layersRoutes = useMemo(() => ([
        { path: "/", element: layers },
        { path: "/:road", element: layers },
        { path: "/:road/:signId", element: <HorizontalSignValidator>{layers}</HorizontalSignValidator> },
    ]), [layers])

    return useRoutes(layersRoutes)
}